
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import AuthService from "@/services/authService";
import DateRangePicker from "vue2-daterange-picker";
import InsightService from "@/services/insightService";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

@Component({
  components: {
    LayoutDefault,
    DateRangePicker
  }
})
export default class Insight extends Vue {
  private authService = new AuthService();
  private insightData: any = [];
  private loading: any = true;
  private hasData: any = false;
  private addButtonDisabled: boolean = false;
  private hover: boolean = false;

  private editModal: boolean = false;
  private editInsightId: number | null = null;

  private editor = ClassicEditor;
  private editorConfig = {
    toolbar: [
      "heading",
      "|",
      "bold",
      "italic",
      "link",
      "bulletedList",
      "numberedList",
      "|",
      "indent",
      "outdent",
      "|",
      "blockQuote",
      "undo",
      "redo"
    ]
  };

  private dateRange: any = {
    startDate: "",
    endDate: ""
  };
  private addInsightForm: any = {
    date: this.dateRange,
    text: ""
  };
  private showAddInsightForm = true;

  private get getInsightAvatarUrl() {
    return process.env.VUE_APP_DASHBOARD_URL + "img/avatar/";
  }

  private updateInsightList() {
    this.authService.show(this.$auth.user().id_platform).then((result: any) => {
      this.insightData = result;
      if (result[0] !== undefined && result[0] !== null) {
        this.hasData = true;
      }
      this.loading = false;
    });
  }

  private mounted() {
    this.updateInsightList();
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  private clearForm() {
    // Reset our form values
    this.addInsightForm.date.startDate = "";
    this.addInsightForm.date.endDate = "";
    this.addInsightForm.text = "";

    // Trick to reset/clear native browser form validation state
    this.showAddInsightForm = false;
    this.$nextTick(() => {
      this.showAddInsightForm = true;
    });
  }

  private showAddInsightModal() {
    if (this.editModal == true) {
      this.editModal = false;
      this.clearForm();
    }
    let insightDate = new Date(Date.now());
    this.addInsightForm.date.startDate = insightDate;
    this.$bvModal.show("modal-add-insight");
  }

  private pad2(number) {
    return (number < 10 ? "0" : "") + number;
  }

  private insightServiceInstance = new InsightService();

  private onSubmit(evt: any) {
    evt.preventDefault();
    this.addButtonDisabled = true;
    this.loading = true;

    let selectedDate = this.addInsightForm.date.startDate;
    let formattedDate = selectedDate
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");

    let data: any = {
      fk_id_user: this.$auth.user().id_user,
      fk_id_platform: this.$auth.user().id_platform,
      insight: this.addInsightForm.text,
      created_at: formattedDate
    };

    // Hides the modal
    this.$bvModal.hide("modal-add-insight");

    if (this.editModal && this.editInsightId != null) {
      this.insightServiceInstance
        .edit_insight(this.editInsightId, data)
        .then((result: any) => {
          this.clearForm();
          this.addButtonDisabled = false;
          this.updateInsightList();
        });
    } else {
      this.insightServiceInstance.add_insight(data).then((result: any) => {
        this.clearForm();
        this.addButtonDisabled = false;
        this.updateInsightList();
      });
    }
  }

  private editInsight(id_insight: number) {
    this.editModal = true;
    this.editInsightId = id_insight;

    let insightObj = this.insightData.find(function(element) {
      return element.id_insight == id_insight;
    });

    // Fill our form values
    let insightDate = new Date(insightObj.created_at);
    this.addInsightForm.date.startDate = insightDate;
    this.addInsightForm.date.endDate = "";
    this.addInsightForm.text = insightObj.insight;

    this.$bvModal.show("modal-add-insight");
  }

  private removeInsight(id_insight: number) {
    this.editInsightId = id_insight;
    this.$bvModal.show("modal-remove-insight");
  }

  private removeInsightConfirm() {
    this.loading = true;

    let data: any = {
      status: "insight_deleted"
    };

    // Hides the modal
    this.$bvModal.hide("modal-remove-insight");

    if (this.editInsightId != null) {
      this.insightServiceInstance
        .edit_insight(this.editInsightId, data)
        .then((result: any) => {
          this.updateInsightList();
        });
    }
  }
}
